import React from 'react';

import { bemBlock } from '../../modules/bem';
import { Layout } from '../layout/Layout';
import { Text } from '../text/Text';

import { getDataName } from './Panel.helpers';
import { type DataNameProps, type PanelIntent } from './Panel.types';

import './PanelTile.less';

const block = bemBlock('n-Panel');

export type PanelTileProps = Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> &
  DataNameProps & {
    children?: React.ReactNode;
    highlighted?: boolean;
    interactive?: boolean;
    intent?: PanelIntent;
    label?: React.ReactNode;
    numeric?: boolean;
    value?: React.ReactNode;
    valueTitle?: string;
  };

export const PanelTile = React.forwardRef<HTMLDivElement, PanelTileProps>(function PanelTile(
  {
    children,
    className,
    dataName,
    highlighted,
    interactive,
    intent,
    label,
    numeric,
    value,
    valueTitle,
    'data-name': dataNameAttribute,
    ...passProps
  },
  ref,
) {
  if (value === undefined && children === undefined) {
    return null;
  }

  return (
    <Layout.Element
      {...passProps}
      elementRef={ref}
      className={block({
        element: 'tile',
        modifiers: { highlighted, interactive, intent, numeric },
        extra: className,
      })}
      data-name={getDataName(dataName, dataNameAttribute)}
    >
      {label !== undefined && (
        <Text size="xs" color="text-secondary" className={block('tile-label')}>
          {label}
        </Text>
      )}
      {children ?? (
        <Text
          size="lg"
          fontWeight="semibold"
          className={block('tile-value')}
          title={valueTitle}
          wordBreak={numeric ? 'normal' : 'break-word'}
        >
          {value}
        </Text>
      )}
    </Layout.Element>
  );
});
